import React from 'react';
import { useRouteError } from 'react-router-dom';

import { LoadableNotFoundPage } from 'ha/pages/NotFound';
import { LoadableHermesNotFoundPage } from 'ha/modules/Hermes/components/HermesNotFoundPage.lazy';
import { LoadableSomethingWentWrongPage } from 'ha/pages/SomethingWentWrongPage';

interface ErrorResponse {
  status: number;
  statusText: string;
  data: any;
  error?: Error;
}

export const RouterErrorBoundary: React.FC = () => {
  const error = useRouteError() as ErrorResponse;

  if (error.status === 404) {
    if (error.data?.isHermes) {
      return <LoadableHermesNotFoundPage />;
    }

    return <LoadableNotFoundPage />;
  }

  if (error.status === 500) {
    return <LoadableSomethingWentWrongPage />;
  }

  return <LoadableSomethingWentWrongPage />;
};
